export const CREATE_SALESFORCE_IMPORT_REQUEST = 'CREATE_SALESFORCE_IMPORT_REQUEST';
export const CREATE_SALESFORCE_IMPORT_SUCCESS = 'CREATE_SALESFORCE_IMPORT_SUCCESS';
export const CREATE_SALESFORCE_IMPORT_FAILED = 'CREATE_SALESFORCE_IMPORT_FAILED';

export const UPDATE_SALESFORCE_IMPORT_REQUEST = 'UPDATE_SALESFORCE_IMPORT_REQUEST';
export const UPDATE_SALESFORCE_IMPORT_SUCCESS = 'UPDATE_SALESFORCE_IMPORT_SUCCESS';
export const UPDATE_SALESFORCE_IMPORT_FAILED = 'UPDATE_SALESFORCE_IMPORT_FAILED';

export const GET_SALESFORCE_IMPORT_REQUEST = 'GET_SALESFORCE_IMPORT_REQUEST';
export const GET_SALESFORCE_IMPORT_SUCCESS = 'GET_SALESFORCE_IMPORT_SUCCESS';
export const GET_SALESFORCE_IMPORT_FAILED = 'GET_SALESFORCE_IMPORT_FAILED';

export const DELETE_SALESFORCE_IMPORT_REQUEST = 'DELETE_SALESFORCE_IMPORT_REQUEST';
export const DELETE_SALESFORCE_IMPORT_SUCCESS = 'DELETE_SALESFORCE_IMPORT_SUCCESS';
export const DELETE_SALESFORCE_IMPORT_FAILED = 'DELETE_SALESFORCE_IMPORT_FAILED';

export const SET_SALESFORCE_IMPORT = 'SET_SALESFORCE_IMPORT';
